import { UserInfoDto } from '@app/shared/models/contracts/userinfo-dto';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '@server/api-config';
import env from '@environment';
import { enumKeyByValue } from '@app/shared/helpers';
import { Role } from '@app/shared/models/contracts/enums/shared-enums';
import { uiValuesSlice } from './ui-values-slice';

export interface UserInfoState {
  userInfo: UserInfoDto;
}

export const fetchUserInfo = createAsyncThunk('userInfo/fetchUserInfo', async (_) => {
  const response = await api.get<UserInfoDto>(`${env.apiUrl}/account/userinfo`);
  return response.data;
});

export const logout = createAsyncThunk('userInfo/logout', async (_, thunkAPI) => {
  await api.get(`${env.apiUrl}/account/logout`);
  thunkAPI.dispatch(uiValuesSlice.actions.setIsLoggedIn(false));
});

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: {
    userInfo: {
      id: 0,
      role: enumKeyByValue(Role, Role.TeamMember),
      fullUserName: '',
      email: '',
    },
  } as UserInfoState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.fulfilled, (state, payload) => {
      state.userInfo = payload.payload;
    });
  },
});

export default userInfoSlice.reducer;
